'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var Twine = _interopDefault(require('twine'));
var QueryString = _interopDefault(require('../../helpers/querystring.js'));
var cookieHelper = _interopDefault(require('../../helpers/cookie-helper.js'));
var URLHelper = _interopDefault(require('../../helpers/url.js'));
var signupTracker = _interopDefault(require('./signup-tracker.js'));

/* eslint-disable camelcase */
function HiddenFields(defaults, node) {
  var qs = this.qs();

  this.fields = {
    forwarded_host: window.location.hostname,
    ssid: qs.ssid || cookieHelper.get('ssid'),
    source: defaults.source || cookieHelper.get('source'),
    source_url: defaults.source_url || cookieHelper.get('source_url'),
    signup_code: defaults.signup_code || qs.signup_code,
    signup_types: defaults.signup_types,
    theme: defaults.theme,
    selected_app: defaults.selected_app,
    selected_plan: defaults.selected_plan,
    y: this.y()
  };

  this.$node = $(node);

  signupTracker.trackHiddenFieldsOnce(this.fields);
  this.signupTypesFromQS();
}

HiddenFields.prototype.y = function () {
  return cookieHelper.get('_y') || cookieHelper.get('_shopify_y');
};

HiddenFields.prototype.setField = function (field, value) {
  this.fields[field] = value;
};

HiddenFields.prototype.qs = function () {
  return QueryString.parse(URLHelper.querystring(window.location.href));
};

HiddenFields.prototype.signupTypesFromQS = function () {
  var _this = this;

  var types = [];
  var inputs = [];

  if (this.qs().signup_types) {
    types = this.qs().signup_types.split(',').filter(function (type) {
      return _this.fields.signup_types.indexOf(type) < 0;
    });

    inputs = types.map(function (type) {
      var input = $('<input>');
      input.attr('name', 'signup_types[]');
      input.attr('type', 'hidden');
      input.val(type);
      return input;
    });

    this.fields.signup_types += types;

    this.$node.append(inputs);
  }
};

Twine.register('HiddenFields', HiddenFields);

/* eslint-enable camelcase */

module.exports = HiddenFields;
